import './locations-map.component.scss'

import loadGoogleMapsApi from 'load-google-maps-api'

const gmapApiKey = document.querySelector('meta[name="google-api-key"]').content
const locationsMap = document.querySelector('.locations-map__map-canvas')
const loadOptions = {
  key: gmapApiKey
}
// const pinUrl = 'images/locations-map__pin.svg'
const mapCoords = {
  lat: 43.35171886107648, 
  lng: -87.0917266368074,
}
const mapMarkers = []

const getMarkers = () => {
  const metaTags = document.querySelectorAll('meta[name*="google-map-link-"]')
  metaTags.forEach(tag => {
    const res = {}
    const name = tag.name
    const location = name.substring(16)

    const pinMeta = document.querySelector(`meta[name*='google-map-coords-${location}']`)

    res.url = tag.content
    res.LatLng = JSON.parse(pinMeta.content)
    mapMarkers.push(res)
  })

  const dataPins = locationsMap.dataset.pins
  if (dataPins) {
    const pinsArray = JSON.parse(dataPins)
    for (let i = 0; i < pinsArray.length; i++) {
      const res = {}
      res.url = pinsArray[i].link
      res.LatLng = {
        lat: pinsArray[i].lat,
        lng: pinsArray[i].lng,
      }
      mapMarkers.push(res)
    }
  }
}

if (locationsMap) {
  getMarkers()
}

const addMarker = map => {
  const markersOnMap = mapMarkers

  // const image = {
  //   url: pinUrl,
  //   size: new google.maps.Size(30, 40),
  //   scaledSize: new google.maps.Size(30, 40),
  //   origin: new google.maps.Point(0, 0),
  //   anchor: new google.maps.Point(15, 40),
  //   labelOrigin: new google.maps.Point(15, 40)
  // }

  for (let i = 0; i < markersOnMap.length; i++) {
    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng,
      map: map,
      // icon: image
    })

    const marker__url = markersOnMap[i].url;
    marker.addListener('click', () => {
      window.open(marker__url, '_blank')
    })
  }
}

if (locationsMap) {
  const els = [
    {
      node: locationsMap,
      callback() {
        loadGoogleMapsApi(loadOptions).then(function (googleMaps) {
          const map = new googleMaps.Map(locationsMap, {
            center: mapCoords,
            zoom: 6,
            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: {
              position: google.maps.ControlPosition.LEFT_CENTER,
            },
            mapTypeControl: true,
            mapTypeControlOptions: {
              position: google.maps.ControlPosition.LEFT_TOP,
            },
          })
          addMarker(map)

          const breakpoint = 667

          const changeCenter = e => {
            if (e) {
              if (e.matches) {
                map.setZoom(6)
              } else {
                map.setZoom(5)
              }
            } else {
              if (window.innerWidth < breakpoint) {
                map.setZoom(5)
              } else {
                map.setZoom(6)
              }
            }

          }

          changeCenter()

          const media = `(min-width: ${breakpoint}px)`
          const mediaWatcher = window.matchMedia(media)
          mediaWatcher.addEventListener('change', changeCenter)
        }).catch(function (error) {
          console.error(error)
        })
      }
    }
  ]

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          els.forEach(el => {
            if (el.node === entry.target) {
              el.callback()
            }
          })
          observer.unobserve(entry.target)
        }
      })
    }, {
      threshold: 0.01,
      rootMargin: '0px 0px 0px 0px'
    }
  )

  els.forEach(el => {
    observer.observe(el.node)
  })
}